import { z } from 'zod';

export const RoundHeaderSchema = z.object({
  rulesVersion: z.number().int(),
  levelId: z.string().max(64),
  levelHash: z.string().length(16),
  seed: z.number().int().min(0).max(0xffffffff),
  assist: z.number().int().min(0).max(2),
  rescueThreshold: z.number().int().min(0).max(9),
  maxRescues: z.number().int().min(0).max(5),
  /** round economy the client played with (economy.json `round`); the server checks it against the player's assignment */
  cfg: z
    .object({
      coinsOrderPop: z.number().int().min(0).max(1000),
      coinsClutterPop: z.number().int().min(0).max(1000),
      coinsSweep: z.number().int().min(0).max(100),
      rescueTimeMs: z.number().int().min(0).max(600000),
    })
    .optional(),
});

export const RoundSubmissionSchema = z.object({
  roundId: z.uuid(),
  mode: z.enum(['level', 'daily', 'beat', 'help', 'tournament', 'duel']).default('level'),
  header: RoundHeaderSchema,
  log: z.string().max(20000).regex(/^[A-Za-z0-9_-]*$/),
  claimed: z.object({
    result: z.enum(['win', 'fail']),
    taps: z.number().int().min(0),
    stars: z.number().int().min(0).max(3),
    coins: z.number().int().min(0),
  }),
  boostersUsed: z.object({ undo: z.number().int().min(0), shuffle: z.number().int().min(0), magnet: z.number().int().min(0), extraSlot: z.number().int().min(0) }).partial().default({}),
  rescue: z.enum(['none', 'free', 'ad', 'gems', 'booster']).array().default([]),
  playedAt: z.number().int(),
});
export type RoundSubmissionDto = z.infer<typeof RoundSubmissionSchema>;
